/**
 * Header Component - Nintendo DS Style
 */

import { useApp } from "../context/AppContext";

function getCartridgeLabel(screen: string): string {
  switch (screen) {
    case "draft":
      return "2P DRAFT";
    case "battle":
      return "BATTLE";
    default:
      return "HOME";
  }
}

export function Header() {
  const { state, dispatch } = useApp();
  const currentTime = new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  const isMuted = !state.audio.sfxEnabled && !state.audio.musicEnabled;

  const handleToggleMute = () => {
    dispatch({ type: "TOGGLE_SFX" });
    dispatch({ type: "TOGGLE_MUSIC" });
  };

  return (
    <div
      className="w-full bg-gradient-to-b from-poke-blue-dark to-poke-blue-darker border-b-2 border-gray-900 py-3 px-6 flex items-center justify-between shadow-lg z-50 relative"
      style={{
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(107, 183, 232, 0.3)',
        borderRadius: '0 0 12px 12px'
      }}
    >
      {/* Left Side */}
      <div className="flex items-center gap-2">
        <div
          className="w-3 h-3 rounded-full bg-green-400 border border-green-600"
          style={{ boxShadow: '0 0 8px rgba(74, 222, 128, 1)' }}
        />
        <span className="text-white font-retro text-xs" style={{ textShadow: '1px 1px 0 rgba(0, 0, 0, 0.5)' }}>
          POKEDEX
        </span>
        <span className="text-white/40 font-retro text-xs mx-1">|</span>
        <span className="text-poke-yellow font-retro text-xs" style={{ textShadow: '1px 1px 0 rgba(0, 0, 0, 0.5)' }}>
          {getCartridgeLabel(state.screen)}
        </span>
      </div>

      {/* Right Side */}
      <div className="flex items-center gap-3 text-white font-retro text-xs">
        {/* Mute button */}
        <button
          onClick={handleToggleMute}
          className="text-white/70 hover:text-white transition-colors"
          title={isMuted ? "Activer le son" : "Couper le son"}
          style={{ textShadow: '1px 1px 0 rgba(0, 0, 0, 0.5)' }}
        >
          {isMuted ? "\uD83D\uDD07" : "\uD83D\uDD0A"}
        </button>

        {/* Wi-Fi indicator */}
        <span className="text-white/70" style={{ textShadow: '1px 1px 0 rgba(0, 0, 0, 0.5)' }}>
          Wi-Fi
        </span>

        {/* Battery */}
        <div className="flex items-center gap-2">
          <div
            className="w-12 h-2 bg-gray-700 border border-gray-900"
            style={{ borderRadius: '2px', boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.5)' }}
          >
            <div className="h-full w-10/12 bg-gradient-to-r from-green-400 to-yellow-400" style={{ borderRadius: '1px' }} />
          </div>
        </div>

        {/* Clock */}
        <span style={{ textShadow: '1px 1px 0 rgba(0, 0, 0, 0.5)' }}>{currentTime}</span>
      </div>
    </div>
  );
}

export default Header;
